'use client';

import { useState } from 'react';
import { GitBranch } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Sourced from packages/landing/public/resources-content/programs-parallel.jpg */
const PARALLEL_PATHWAY_EXAMPLE = '/program-pathways/programs-parallel.jpg';
const PARALLEL_PATHWAY_EXAMPLE_FALLBACK = '/program-pathways/parallel-branches-example.svg';

export function ProgramPathwayParallelBranchesTip({ className }: { className?: string }) {
  const [src, setSrc] = useState(PARALLEL_PATHWAY_EXAMPLE);

  return (
    <aside
      className={cn(
        'rounded-lg border border-indigo-200/80 bg-indigo-50/40 p-4 space-y-3 dark:border-indigo-800/80 dark:bg-indigo-950/25',
        className
      )}
      aria-labelledby="parallel-pathway-tip-heading"
    >
      <div className="flex items-start gap-2.5">
        <GitBranch
          className="w-4 h-4 shrink-0 text-indigo-600 dark:text-indigo-400 mt-0.5"
          aria-hidden
        />
        <div className="min-w-0 space-y-1.5">
          <p
            id="parallel-pathway-tip-heading"
            className="text-sm font-medium text-gray-900 dark:text-white"
          >
            Need invitation-only or selective squads?
          </p>
          <p className="text-xs leading-relaxed text-gray-600 dark:text-gray-400">
            After you create this pathway, add <strong>parallel programs</strong> at the same stage
            (use <strong>Parallel branch</strong> on the Programs page). Set the same{' '}
            <strong>This program follows</strong> predecessor, turn on{' '}
            <strong>Invitation only</strong> on the selective program, and link lessons to that
            copy.
          </p>
        </div>
      </div>
      <figure className="m-0">
        <div className="overflow-hidden rounded-md border border-dashed border-gray-300 bg-gray-50 dark:border-gray-600 dark:bg-gray-900/40">
          <img
            src={src}
            alt="Example of parallel program branches on the Programs pathway view"
            className="w-full h-auto object-contain"
            onError={() => {
              if (src !== PARALLEL_PATHWAY_EXAMPLE_FALLBACK) {
                setSrc(PARALLEL_PATHWAY_EXAMPLE_FALLBACK);
              }
            }}
          />
        </div>
        <figcaption className="mt-1.5 text-[11px] text-gray-500 dark:text-gray-400 text-center">
          Parallel branches share a predecessor—for example open Orange vs invitation-only Orange
          Performance.
        </figcaption>
      </figure>
    </aside>
  );
}
